module.exports = __webpack_public_path__ + "static/linkedin-6a77e0da5cb156c399828c8bb870ea95.png";